<template>
  <section>
    <PolicyHeader />
    <PolicyIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Policy',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.policy || {}
    }
  },
  mounted() {
    console.log('policy', this.$wp.pages.policy)
  }
}
</script>
